export default "__VITE_ASSET__CxDV6wFD__"